export default "__VITE_ASSET__BI01Uto4__";